module.exports = __webpack_public_path__ + "img/Celloger Stack.f66ac70f.png";